/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_FORM_SPLIT_COMPONENTS_SELECTOR
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted Type Selector and Photo button from BroadcastForm.tsx.
 */

// [2026-02-07] style-extraction: moved inline styles to SCSS module
// [2026-02-07] hide-photo-button: removed "Add via photo" button per user request
import React from "react";

interface BroadcastTypeSelectorProps {
  type: string;
  setType: (val: string) => void;
  errors: any;
  touched: any;
  pendingJobId: string | null;
  onPhotoClick: () => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onFileSelected: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const BroadcastTypeSelector: React.FC<BroadcastTypeSelectorProps> = ({
  type,
  setType,
  errors,
  touched,
  pendingJobId,
  onPhotoClick,
  fileInputRef,
  onFileSelected,
}) => {
  return (
    <div className="card p-3 mb-3">
      <div className="row g-3">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <div>
            <label className="form-label fw-semibold mb-1">Broadcast Type</label>
            <div className="d-flex gap-4">
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="type"
                  id="type-wtb"
                  value="WTB"
                  checked={type === "WTB"}
                  onChange={(e) => setType(e.target.value)}
                />
                <label className="form-check-label" htmlFor="type-wtb">
                  WTB (Want to Buy)
                </label>
              </div>

              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="type"
                  id="type-wts"
                  value="WTS"
                  checked={type === "WTS"}
                  onChange={(e) => setType(e.target.value)}
                />
                <label className="form-check-label" htmlFor="type-wts">
                  WTS (Want to Sell)
                </label>
              </div>
            </div>
            {errors.type && touched.type && (
              <div className="text-danger small mt-1">{errors.type}</div>
            )}
          </div>

          {/* [2026-02-07] hide-photo-button: Hidden "Add via photo" feature */}
          <div className="d-flex align-items-center gap-2">
            {pendingJobId && (
              <span className="badge text-bg-secondary d-inline-flex align-items-center">
                <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                Analyzing image…
              </span>
            )}
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              capture="environment"
              className="d-none"
              onChange={onFileSelected}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadcastTypeSelector;
